import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiRequest } from '../api';
import { API_ENDPOINTS, STORAGE_KEYS } from '../config';
import { useI18n } from '../i18n';
import './Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t, basePath } = useI18n();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.username || !formData.password) {
      setError(t('auth.error.required'));
      return;
    }

    setLoading(true);
    try {
      const result = await apiRequest(API_ENDPOINTS.login, {
        method: 'POST',
        body: JSON.stringify({
          username: formData.username,
          password: formData.password
        })
      });

      localStorage.setItem(STORAGE_KEYS.isLoggedIn, 'true');
      localStorage.setItem(STORAGE_KEYS.username, result.username || formData.username);
      localStorage.setItem(STORAGE_KEYS.accessToken, result.token);
      localStorage.setItem(STORAGE_KEYS.registryUrl, result.registry_url || '');

      setLoading(false);
      navigate(`${basePath}/leaderboard`);
    } catch (err) {
      setError(err.message || t('auth.login')); // fallback message
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-background">
        <div className="bg-gradient"></div>
        <div className="bg-grid"></div>
      </div>
      
      <div className="auth-card">
        <div className="auth-header">
          
          <h1 className="auth-title">{t('auth.login.title')}</h1>
          <p className="auth-subtitle">{t('auth.login.subtitle')}</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && (
            <div className="auth-error">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">{t('auth.username')}</label>
            <div className="input-wrapper">
              <span className="input-icon">👤</span>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder={t('auth.username')}
                autoComplete="username"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">{t('auth.password')}</label>
            <div className="input-wrapper">
              <span className="input-icon">🔒</span>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder={t('auth.password')}
                autoComplete="current-password"
              />
            </div>
          </div>

          <div className="form-options">
            <label className="checkbox-label">
              <input type="checkbox" />
              <span className="checkmark"></span>
              {t('auth.remember')}
            </label>
            <a href="#forgot" className="forgot-link">{t('auth.forgot')}</a>
          </div>

          <button 
            type="submit" 
            className={`auth-submit ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="btn-spinner"></span>
                {t('auth.login.loading')}
              </>
            ) : (
              t('auth.login')
            )}
          </button>
        </form>

        <div className="auth-footer">
          <p>{t('auth.noAccount')}</p>
          <Link to={`${basePath}/leaderboard/register`} className="auth-link">{t('auth.toRegister')}</Link>
        </div>

        <Link to={`${basePath}/leaderboard`} className="back-home">
          ← {t('auth.backHome')}
        </Link>
      </div>
    </div>
  );
};

export default Login;
